import { render, staticRenderFns } from "./CommonDocsList.vue?vue&type=template&id=2387c8f1&scoped=true&"
import script from "./CommonDocsList.vue?vue&type=script&lang=js&"
export * from "./CommonDocsList.vue?vue&type=script&lang=js&"
import style0 from "./CommonDocsList.vue?vue&type=style&index=0&id=2387c8f1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387c8f1",
  null
  
)

export default component.exports